// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner_MxmId","map":"Banner_map_RWeAU","image":"Banner_image__M1Hc"};